export const SHIFT_CREATE_REQUEST = "SHIFT_CREATE_REQUEST"
export const SHIFT_DELETE_REQUEST = "SHIFT_DELETE_REQUEST"
export const SHIFT_UPDATE_REQUEST = "SHIFT_UPDATE_REQUEST"
export const SHIFT_DETAILS_REQUEST = "SHIFT_DETAILS_REQUEST"
export const GET_SHIFTS_REQUEST = "GET_SHIFTS_REQUEST"


